<template>
  <div>
    <Toolbar v-if="schedule"></Toolbar>

    <Popup></Popup>
    <!-- <RowGroup v-for=""></RowGroup> -->
    <div id="grid_container" v-if="!loading">
      <div id="data_sidebar" v-on:scroll="setScrollPosition('sidebar')">
        <div class="wc-spacer overline" :style="{height: headerheight+'px'}">Subproject Works</div>
        <RowGroup v-for="(items, groupname) in groupedSchedule" v-bind:key="groupname" :groupName="groupname" :items="items">{{groupname}} {{items}}</RowGroup>
      </div>
      <div id="data_grid" v-on:scroll="setScrollPosition('grid')" v-if="show_grid">
          <div id="header">
              <CellHeaders></CellHeaders>
          </div>
        <div id="data_table">
        <GridRowGroup v-for="(items, groupname) in groupedSchedule" v-bind:key="groupname" :groupName="groupname" :items="items">{{groupname}} {{items}}</GridRowGroup>
        <CreateSplit></CreateSplit>
        </div>
      </div>
      </div>
    
    <div v-if="loading" class="align-center pa-8" style="text-align:center">
      
        <v-progress-circular
        :size="70"
        :width="5"
        indeterminate
      ></v-progress-circular>
      <div class="caption pa-2 mt-4">{{loadmessage}}</div>
    </div>
    <!-- <Row v-for="row in schedule" v-bind:key="row.spw.ID" :row="row"></Row> -->

  </div>
</template>

<script>
// import Row from './Row';
import RowGroup from './RowGroup'
import Popup from './Popup'
import CellHeaders from './CellHeaders'
import GridRowGroup from './GridRowGroup'
import CreateSplit from './CreateSplit'
import Toolbar from './Toolbar';
import { mapState } from 'vuex'
import { mapGetters } from 'vuex'
// import { mapActions } from 'vuex'
// import { mapMutations } from 'vuex'
// import { mapFields } from 'vuex-map-fields';

  export default {
    name: 'Main',
    components: {
      RowGroup,
      Toolbar,
      GridRowGroup,
      CreateSplit,
      Popup,
      CellHeaders
    },
    data: () => ({
  
    }),
    computed: {
      ...mapState(['cellwidth','headerheight','cellheight','show_grid','loading','moment','loadmessage']),
      ...mapGetters(['schedule','groupedSchedule','date_range','grid_width'])
    },
    methods: {
      setScrollPosition(source) {
      if(this.show_grid && source == 'grid'){
        document.getElementById("data_sidebar").scrollTop = document.getElementById("data_grid").scrollTop;
      }
      if (this.show_grid && source == 'sidebar'){
        document.getElementById("data_grid").scrollTop = document.getElementById("data_sidebar").scrollTop;
      }
    },
    },
    watch: {
  
    }
  }
</script>

<style>

#grid_container{
	display:flex;
	width: 100vw;
	height:calc(100vh - 96px);
}
#data_grid{
	height: 100%;
	overflow:scroll;
	position:relative;
  
}
#header{
	position: -webkit-sticky;
	position: sticky;
	top:0;
  z-index:1;
}
#data_sidebar::-webkit-scrollbar {
  display: none;
}
#data_sidebar{
	width:400px;
	min-width:400px;
  flex:1;
	overflow-y: scroll;
	-ms-overflow-style: none;  /* IE and Edge */
	scrollbar-width: none;  /* Firefox */
  border-right: solid 1px #cccccc;
  padding-bottom: 15px;
}

.wc-spacer{
  background-color:#dfdfdf;
  border-top: solid 1px #cccccc;
  position: sticky;
    top: 0;
    z-index: 1;
    display:flex;
    align-items: center;
    padding-left: 10px;
    border-bottom: solid 1px #cccccc;
}
.todayHeader{
  background-color:#E3F2FD;
  border-left: solid 3px #90CAF9;
    border-right: solid 3px #90CAF9;
    color: #1565C0;
}
</style>
